<template>
  <div>
    <Layout :containers="containers">
      <template v-slot:header>
        <DefaultHeroBar
          :hasQuickStartCallout="false"
          :heroTitle="'Plan ahead: Calculate your estate administration costs'"
          :heroDescription="'Use our free calculator to plan for estate administration fees and protect your loved ones.'"
          :section="'calculator'"
        />
      </template>
      <template v-slot:tabbed-content>
        <Breadcrumb />
        <TitleRow
          :title="computedTitle"
          :description="`Along with the heartache of death comes the additional burden of legal and administration fees. 
          It is important to plan for these costs so it does not cause stress for your loved ones at a time of grieving.`"
        />
        <TabbedContentComponent
          v-if="!hideTabs"
          :tabTitles="[
            'Estate Administration Cost Calculator',
            'Capital Gains Tax Calculator',
          ]"
          :activeTab="parseInt(activeTab)"
        >
          <template v-slot:tab-zero>
            <EstateCostCalculator v-if="whitelabel.omDesign" />
            <EstateAdministrationCostCalculator v-else />
          </template>
          <template v-slot:tab-one>
            <CapitalTaxGainsCalculator />
          </template>
        </TabbedContentComponent>
        <div v-else>
          <div v-if="whitelabel.omDesign">
            <EstateCostCalculator v-if="activeTab === 0" />
            <CapitalTaxGainsCalculator v-if="activeTab === 1" />
          </div>
          <div v-else>
            <EstateAdministrationCostCalculator v-if="activeTab === 0" />
            <CapitalTaxGainsCalculator v-if="activeTab === 1" />
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <CalculatorFooter
          @requestACall="requestACall"
          v-if="whitelabel.brand !== 'quickwill'"
        />
      </template>
    </Layout>
  </div>
</template>
<script>
import Layout from "../../common/layouts/Layout.vue";
import DefaultHeroBar from "../../common/DefaultHeroBar.vue";
import Breadcrumb from "../../common/Breadcrumb.vue";
import TabbedContentComponent from "../../common/TabbedContentComponent.vue";
import EstateCostCalculator from "./estate_cost_calculator/EstateCostCalculator.vue";
import TitleRow from "../../common/TitleRow.vue";
import CapitalTaxGainsCalculator from "./capital_gains_tax/CapitalTaxGainsCalculator.vue";
import CalculatorFooter from "./CalculatorFooter.vue";
import EstateAdministrationCostCalculator from "../EstateCostCalculator/EstateAdministrationCostCalculator.vue";
export default {
  name: "CalculatorsContainer",
  components: {
    DefaultHeroBar,
    Layout,
    Breadcrumb,
    TabbedContentComponent,
    TitleRow,
    EstateCostCalculator,
    CapitalTaxGainsCalculator,
    CalculatorFooter,
    EstateAdministrationCostCalculator,
  },
  props: {
    activeTab: {
      type: Number,
      default: 0,
    },
    hideTabs: {
      type: Boolean,
      default: false,
    },
  },
  metaInfo() {
    return {
      title: this.whitelabel.metaData.calculator.title,
      meta: [
        {
          name: "description",
          content: this.whitelabel.metaData.calculator.description,
        },
        {
          property: "og:title",
          content: this.whitelabel.metaData.calculator.ogTitle,
        },
        {
          property: "og:image",
          content: this.whitelabel.metaData.calculator.ogImage,
        },
        {
          property: "og:type",
          content: this.whitelabel.metaData.calculator.ogType,
        },
        {
          property: "og:url",
          content: this.whitelabel.metaData.calculator.ogUrl,
        },
        {
          property: "og:description",
          content: this.whitelabel.metaData.calculator.description,
        },
        {
          property: "og:site_name",
          content: this.whitelabel.metaData.calculator.ogSiteName,
        },
      ],
    };
  },
  data() {
    return {
      successMessage: null,
      errorMessage: null,
      showSuccess: false,
      showError: false,
      showAlert: false,
      alertMessage: null,
      showRequestACallDialog: false,
    };
  },
  computed: {
    containers() {
      return [
        {
          name: "header",
          background: "countryPattern",
          class: "hero-banner",
        },
        {
          name: "tabbed-content",
          background: "countryPattern",
          fadedRow: true,
          accents: ["green-accent-1"],
          class: "tabbed-content",
        },
        {
          name: "footer",
        },
      ];
    },
    computedTitle() {
      if (this.hideTabs) {
        return "";
      } else {
        return "Our Calculators";
      }
    },
  },
  methods: {
    requestACall() {
      this.showRequestACallDialog = true;
    },
  },
};
</script>
